// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5yfbQ","newExpiryDate":"styles_newExpiryDate__2rN5e","footer":"styles_footer__1Xgdb"};